// United Airlines fleet configurations
// 767-300ER Tail Number to Configuration Mapping
// High-J (76L): 46 Polaris seats - former 2-cabin aircraft + Hawaiian acquisitions
// Standard (76A/76Q): 30 Polaris seats - former 3-cabin aircraft
export const TAIL_TO_CONFIG = {
  // High-J Configuration (46 Polaris, 22 Premium Plus) - 24 aircraft
  // Former 2-cabin 767s and Hawaiian acquisitions
  'N656UA': 'high-j',
  'N657UA': 'high-j',
  'N658UA': 'high-j',
  'N659UA': 'high-j',
  'N660UA': 'high-j',
  'N661UA': 'high-j',
  'N662UA': 'high-j',
  'N663UA': 'high-j',
  'N664UA': 'high-j',
  'N665UA': 'high-j',
  'N666UA': 'high-j', // Confirmed High-J
  'N667UA': 'high-j',
  'N668UA': 'high-j',
  'N669UA': 'high-j',
  'N670UA': 'high-j',
  'N671UA': 'high-j',
  'N672UA': 'high-j',
  'N673UA': 'high-j',
  'N674UA': 'high-j',
  'N675UA': 'high-j',
  'N676UA': 'high-j',
  'N677UA': 'high-j',
  // Ex-Hawaiian 767s
  'N580UA': 'high-j',
  'N581UA': 'high-j',
  'N582UA': 'high-j',
  
  // Standard Configuration (30 Polaris, 24 Premium Plus) - 13 aircraft
  // Former 3-cabin 767s
  'N641UA': 'standard',
  'N642UA': 'standard',
  'N643UA': 'standard',
  'N644UA': 'standard',
  'N645UA': 'standard',
  'N646UA': 'standard',
  'N647UA': 'standard',
  'N648UA': 'standard',
  'N649UA': 'standard',
  'N651UA': 'standard',
  'N652UA': 'standard',
  'N653UA': 'standard',
  'N654UA': 'standard',
};

export const AIRCRAFT_CONFIGS = {
  // Boeing Narrowbody
  "Boeing 737-700": {
    configs: ["2-2 First, 3-3 Economy"],
    type: "narrowbody",
    silhouette: "737",
  },
  "Boeing 737-800": {
    configs: ["2-2 First, 3-3 Economy"],
    type: "narrowbody",
    silhouette: "737",
  },
  "Boeing 737-900": {
    configs: ["2-2 First, 3-3 Economy"],
    type: "narrowbody",
    silhouette: "737",
  },
  "Boeing 737 MAX 8": {
    configs: ["2-2 First, 3-3 Economy"],
    type: "narrowbody",
    silhouette: "737",
  },
  "Boeing 737 MAX 9": {
    configs: ["2-2 First, 3-3 Economy"],
    type: "narrowbody",
    silhouette: "737",
  },
  "Boeing 737 MAX 10": {
    configs: ["2-2 First, 3-3 Economy"],
    type: "narrowbody",
    silhouette: "737",
  },
  "Boeing 757-200": {
    configs: ["2-2 First, 3-3 Economy"],
    type: "narrowbody",
    silhouette: "757",
  },
  "Boeing 757-300": {
    configs: ["2-2 First, 3-3 Economy"],
    type: "narrowbody",
    silhouette: "757",
  },
  // Boeing Widebody
  "Boeing 767-300ER": {
    configs: [
      "1-1-1 Polaris (46), 2-2-2 Premium Plus, 2-3-2 Economy (High-J)",
      "1-1-1 Polaris (30), 2-2-2 Premium Plus, 2-3-2 Economy (Standard)",
    ],
    type: "widebody",
    silhouette: "767",
  },
  "Boeing 767-400ER": {
    configs: ["1-1-1 Polaris, 2-2-2 Premium Plus, 2-3-2 Economy"],
    type: "widebody",
    silhouette: "767",
  },
  "Boeing 777-200": {
    configs: ["2-4-2 Polaris, 2-4-2 Premium Plus, 3-4-3 Economy"],
    type: "widebody",
    silhouette: "777",
  },
  "Boeing 777-200ER": {
    configs: ["2-4-2 Polaris, 2-4-2 Premium Plus, 3-4-3 Economy"],
    type: "widebody",
    silhouette: "777",
  },
  "Boeing 777-300ER": {
    configs: ["1-2-1 Polaris, 2-4-2 Premium Plus, 3-4-3 Economy"],
    type: "widebody",
    silhouette: "777",
  },
  "Boeing 787-8": {
    configs: ["1-2-1 Polaris, 2-3-2 Premium Plus, 3-3-3 Economy"],
    type: "widebody",
    silhouette: "787",
  },
  "Boeing 787-9": {
    configs: ["1-2-1 Polaris, 2-3-2 Premium Plus, 3-3-3 Economy"],
    type: "widebody",
    silhouette: "787",
  },
  "Boeing 787-10": {
    configs: ["1-2-1 Polaris, 2-4-2 Premium Plus, 3-3-3 Economy"],
    type: "widebody",
    silhouette: "787",
  },
  // Airbus
  "Airbus A319": {
    configs: ["2-2 First, 3-3 Economy"],
    type: "narrowbody",
    silhouette: "a320",
  },
  "Airbus A320": {
    configs: ["2-2 First, 3-3 Economy"],
    type: "narrowbody",
    silhouette: "a320",
  },
  "Airbus A321": {
    configs: ["2-2 First, 3-3 Economy"],
    type: "narrowbody",
    silhouette: "a321",
  },
  "Airbus A321neo": {
    configs: ["2-2 First, 3-3 Economy"],
    type: "narrowbody",
    silhouette: "a321",
  },
  "Airbus A350-900": {
    configs: ["1-2-1 Polaris, 2-4-2 Premium Plus, 3-3-3 Economy"],
    type: "widebody",
    silhouette: "a350",
  },
  // Regional
  "Embraer E175": {
    configs: ["1-2 First, 2-2 Economy"],
    type: "regional",
    silhouette: "e175",
  },
};

export const AIRCRAFT_GROUPS = [
  {
    label: "Boeing Narrowbody",
    aircraft: [
      "Boeing 737-700",
      "Boeing 737-800",
      "Boeing 737-900",
      "Boeing 737 MAX 8",
      "Boeing 737 MAX 9",
      "Boeing 737 MAX 10",
      "Boeing 757-200",
      "Boeing 757-300",
    ],
  },
  {
    label: "Boeing Widebody",
    aircraft: [
      "Boeing 767-300ER",
      "Boeing 767-400ER",
      "Boeing 777-200",
      "Boeing 777-200ER",
      "Boeing 777-300ER",
      "Boeing 787-8",
      "Boeing 787-9",
      "Boeing 787-10",
    ],
  },
  {
    label: "Airbus",
    aircraft: [
      "Airbus A319",
      "Airbus A320",
      "Airbus A321",
      "Airbus A321neo",
      "Airbus A350-900",
    ],
  },
  {
    label: "Regional",
    aircraft: ["Embraer E175"],
  },
];

export const CLASS_OF_SERVICE = [
  { value: "Polaris Business", rarity: "legendary", color: "#0033A0" },  // United dark blue
  { value: "United First", rarity: "epic", color: "#60A5FA" },          // Light blue
  { value: "Premium Plus", rarity: "rare", color: "#9333EA" },          // Purple
  { value: "Economy Plus", rarity: "uncommon", color: "#22C55E" },      // Green
  { value: "Economy", rarity: "common", color: "#6B7280" },             // Gray
];
